<template>
  <v-container
    id="regular-tables"
    fluid
    tag="section"
  >
    <v-menu
      v-if="isMobile"
      offset-x
      right
    >
      <template #activator="{ on, attrs }">
        <v-icon
          dark
          large
          color="#37474F"
          v-bind="attrs"
          v-on="on"
        >
          mdi-menu
        </v-icon>
      </template>
      <v-list
        nav
        dense
      >
        <v-list-item-group
          v-model="selectedItem"
          color="#37474F"
          mandatory
        >
          <v-list-item
            link
            @click="getDigiBoardAdvertisers()"
          >
            <v-list-item-icon>
              <v-icon style="font-size:25px;color:#37474F;font-weight:bold;">
                mdi-credit-card-clock-outline
              </v-icon>
            </v-list-item-icon>
            <v-list-item-title
              style="font-size:14px;color:#37474F;font-weight:bold;"
            >
              Advertisers
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            link
            @click="getDigiBoardTimeSlots()"
          >
            <v-list-item-icon>
              <v-icon style="font-size:25px;color:#37474F;font-weight:bold;">
                mdi-clipboard-text-clock-outline
              </v-icon>
            </v-list-item-icon>
            <v-list-item-title
              style="font-size:14px;color:#37474F;font-weight:bold;"
            >
              Time Slots
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            link
            @click="getSettingsDetails()"
          >
            <v-list-item-icon>
              <v-icon style="font-size:25px;color:#37474F;font-weight:bold;">
                mdi-cog-outline
              </v-icon>
            </v-list-item-icon>
            <v-list-item-title
              style="font-size:14px;color:#37474F;font-weight:bold;"
            >
              Settings
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            link
            @click="getDigiBoardLicenceDetails()"
          >
            <v-list-item-icon>
              <v-icon style="font-size:25px;color:#37474F;font-weight:bold;">
                mdi-monitor-lock
              </v-icon>
            </v-list-item-icon>
            <v-list-item-title
              style="font-size:14px;color:#37474F;font-weight:bold;"
            >
              Licence
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            link
            @click="getDigiBoardImages()"
          >
            <v-list-item-icon>
              <v-icon style="font-size:25px;color:#37474F;font-weight:bold;">
                mdi-cloud-upload-outline
              </v-icon>
            </v-list-item-icon>
            <v-list-item-title
              style="font-size:14px;color:#37474F;font-weight:bold;"
            >
              Board Images
            </v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-menu>
    <v-btn
      color="red darken-3"
      class="ml-7 my-back-btn-style"
      text
      x-large
      dark
      @click="back()"
    >
      <v-icon
        left
        dark
      >
        mdi-arrow-left-bold
      </v-icon>
      Back
    </v-btn>
    <v-navigation-drawer
      v-if="!isMobile"
      permanent
      color="#ECEFF1"
      expand-on-hover
      absolute
      bottom
      floating
    >
      <v-list>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="nav-title-style">
              <v-list-item-icon>
                <v-icon
                  style="font-size:25px;color:#37474F;font-weight:bold;"
                >
                  mdi-monitor-dashboard
                </v-icon>
              </v-list-item-icon>
              Board Details
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-divider />
      <br>
      <v-list
        nav
        dense
      >
        <v-list-item-group
          v-model="selectedItem"
          color="#37474F"
          mandatory
        >
          <v-list-item
            link
            @click="getDigiBoardAdvertisers()"
          >
            <v-list-item-icon>
              <v-icon style="font-size:25px;color:#37474F;font-weight:bold;">
                mdi-credit-card-clock-outline
              </v-icon>
            </v-list-item-icon>
            <v-list-item-title
              style="font-size:14px;color:#37474F;font-weight:bold;"
            >
              Advertisers
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            link
            @click="getDigiBoardTimeSlots()"
          >
            <v-list-item-icon>
              <v-icon style="font-size:25px;color:#37474F;font-weight:bold;">
                mdi-clipboard-text-clock-outline
              </v-icon>
            </v-list-item-icon>
            <v-list-item-title
              style="font-size:14px;color:#37474F;font-weight:bold;"
            >
              Time Slots
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            link
            @click="getSettingsDetails()"
          >
            <v-list-item-icon>
              <v-icon style="font-size:25px;color:#37474F;font-weight:bold;">
                mdi-cog-outline
              </v-icon>
            </v-list-item-icon>
            <v-list-item-title
              style="font-size:14px;color:#37474F;font-weight:bold;"
            >
              Settings
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            link
            @click="getDigiBoardLicenceDetails()"
          >
            <v-list-item-icon>
              <v-icon style="font-size:25px;color:#37474F;font-weight:bold;">
                mdi-monitor-lock
              </v-icon>
            </v-list-item-icon>
            <v-list-item-title
              style="font-size:14px;color:#37474F;font-weight:bold;"
            >
              Licence
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            link
            @click="getDigiBoardImages()"
          >
            <v-list-item-icon>
              <v-icon style="font-size:25px;color:#37474F;font-weight:bold;">
                mdi-cloud-upload-outline
              </v-icon>
            </v-list-item-icon>
            <v-list-item-title
              style="font-size:14px;color:#37474F;font-weight:bold;"
            >
              Board Images
            </v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
    <div>
      <digi-board-time-slots-list v-if="showDigiBoardTimeSlots" />
      <digi-board-settings-details v-if="showSettingsDetails" />
      <digi-board-advertisers v-if="showDigiBoardAdvertisers" />
      <digi-board-licence-details v-if="showDigiBoardLicenceDetails" />
      <list-board-images v-if="showBoardImages" />
    </div>
  </v-container>
</template>

<script>
  import DigiBoardTimeSlotsList from './digiboardtimeslots/DigiBoardTimeSlotsList.vue';
  import DigiBoardSettingsDetails from 'src/views/dashboard/digiboards/DigiBoardSettingsDetails.vue';
  import DigiBoardAdvertisers from './DigiBoardAdvertisers.vue';
  import DigiBoardLicenceDetails from './DigiBoardLicenceDetails.vue';
  import ListBoardImage from './digiboardimages.vue/ListBoardImages.vue';

  export default {
    name: 'DigiBoardDetailsLandingPage',
    components: {
      'digi-board-time-slots-list': DigiBoardTimeSlotsList,
      'digi-board-settings-details': DigiBoardSettingsDetails,
      'digi-board-advertisers': DigiBoardAdvertisers,
      'digi-board-licence-details': DigiBoardLicenceDetails,
      'list-board-images': ListBoardImage,
    },
    data: () => ({
      selectedItem: -1,
      showDigiBoardTimeSlots: false,
      showSettingsDetails: false,
      showDigiBoardAdvertisers: true,
      showDigiBoardLicenceDetails: false,
      showBoardImages: false,
    }),
    computed: {
      isMobile () {
        if (this.$vuetify.breakpoint.md || this.$vuetify.breakpoint.lg || this.$vuetify.breakpoint.xl) {
          return false;
        } else {
          return true;
        }
      },
    },
    mounted () {
      this.selectedItem = 0;
    },
    methods: {
      getSettingsDetails () {
        this.showDigiBoardTimeSlots = false;
        this.showDigiBoardAdvertisers = false;
        this.showSettingsDetails = true;
        this.showDigiBoardLicenceDetails = false;
      },
      getDigiBoardTimeSlots () {
        this.showSettingsDetails = false;
        this.showDigiBoardAdvertisers = false;
        this.showBoardImages = false;
        this.showDigiBoardTimeSlots = true;
        this.showDigiBoardLicenceDetails = false;
      },
      getDigiBoardAdvertisers () {
        this.showDigiBoardTimeSlots = false;
        this.showSettingsDetails = false;
        this.showDigiBoardAdvertisers = true;
        this.showBoardImages = false;
        this.showDigiBoardLicenceDetails = false;
      },
      back () {
        this.$router.push({ name: 'DigiBoards' });
      },
      getDigiBoardLicenceDetails () {
        this.showDigiBoardTimeSlots = false;
        this.showSettingsDetails = false;
        this.showDigiBoardAdvertisers = false;
        this.showBoardImages = false;
        this.showDigiBoardLicenceDetails = true;
      },
      getDigiBoardImages () {
        this.showDigiBoardTimeSlots = false;
        this.showSettingsDetails = false;
        this.showDigiBoardAdvertisers = false;
        this.showDigiBoardLicenceDetails = false;
        this.showBoardImages = true;
      },
    },
  };

</script>
<style scoped>
.nav-title-style {
  font-family: 'Times New Roman', Times, serif;
  font-weight: bold;
  color: #37474F;
  font-size: 25px;
}
.my-back-btn-style {
  margin-bottom: -20px;
}
@media (max-width: 960px) {
  .my-back-btn-style {
    margin-bottom: 0px;
    margin-left: 0px !important;
  }
}
</style>
